import {formatJson, formatYaml, formatXml} from '../../../utils/converters';
import {jsonSample, yamlSample, xmlSample} from '../../../utils/sampleData';
import markdownSample from './markdownSample';

const editorTypes = [
    {
        key: 'markdown',
        label: 'Markdown',
        language: 'markdown',
        placeholder: markdownSample,
        extension: 'md',
        mimeType: 'text/markdown',
    },
    {
        key: 'json',
        label: 'JSON',
        language: 'json',
        placeholder: jsonSample,
        extension: 'json',
        mimeType: 'application/json',
        format: formatJson,
    },
    {
        key: 'yaml',
        label: 'YAML',
        language: 'yaml',
        placeholder: yamlSample,
        extension: 'yaml',
        mimeType: 'application/x-yaml',
        format: formatYaml,
    },
    {
        key: 'xml',
        label: 'XML',
        language: 'xml',
        placeholder: xmlSample,
        extension: 'xml',
        mimeType: 'application/xml',
        format: formatXml,
    },
]

export default editorTypes
